export default __webpack_public_path__ + "static/media/select-arrow.9069c87f.svg";